export function price(value) {
    return value + ' €';
  }